import React, { useEffect, useState, useRef } from 'react';

import { Box, Card } from '@sunwisesoftware/sunwise-ui';
import { debounce, isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { DEBOUNCE_TIME } from 'common/constants';

import BulkOperationsCard from './BulkOperationsCard';
import EmptyStateAndList from './EmptyStateAndList';
import Filters from './Filters';

const Content = ({
    contacts,
    filterContacts,
    filterData,
    handleClickBulkItems,
    handleClickCreate,
    handleSaveRow,
    isFetching,
    paginationData,
    setFilterData,
    showEmptyState,
    tableSettings,
    users,
}) => {
    const [rowCount, setRowCount] = useState(paginationData?.rowCount || 0);
    const [selectedBulkOption, setSelectedBulkOption] = useState('');
    const [selectionModel, setSelectionModel] = useState([]);
    const [currentFilterData, setCurrentFilterData] = useState(filterData);

    useEffect(() => {
        if (paginationData)
            setRowCount((prevRowCount) =>
                paginationData?.total_rows !== undefined
                    ? paginationData?.total_rows
                    : prevRowCount,
            );
    }, [paginationData?.total_rows, setRowCount]);

    useEffect(() => {
        if (!isEqual(currentFilterData, filterData)) {
            handleOnFilter(filterData);
            setCurrentFilterData(filterData);
        }
    }, [filterData]);

    const handleOnFilter = useRef(
        debounce((filter) => filterContacts(filter), DEBOUNCE_TIME),
    ).current;

    const handleOnChangeSearch = (event) => {
        setFilterData({
            ...filterData,
            page: 0,
            searchText: event.target.value,
        });
    };

    const handleOnSelectUser = (item) => {
        const filter = {
            ...filterData,
            userId: item.value,
            page: 0,
        };
        setFilterData(filter);
    };

    const handleOnSelectStatus = (value) => {
        const filter = { ...filterData, page: 0, status: value };
        setFilterData(filter);
    };

    return (
        <Box>
            <Filters
                filterData={filterData}
                handleOnChangeSearch={handleOnChangeSearch}
                handleOnSelectUser={handleOnSelectUser}
                handleOnSelectStatus={handleOnSelectStatus}
                selectionModel={selectionModel}
                users={users}
            />
            <Card>
                <Card.Body>
                    <BulkOperationsCard
                        filterData={filterData}
                        handleClickBulkItems={handleClickBulkItems}
                        selectedBulkOption={selectedBulkOption}
                        selectionModel={selectionModel}
                        setSelectedBulkOption={setSelectedBulkOption}
                        setSelectionModel={setSelectionModel}
                    />
                    <EmptyStateAndList
                        contacts={contacts}
                        filterData={filterData}
                        handleClickBulkItems={handleClickBulkItems}
                        handleClickCreate={handleClickCreate}
                        handleSaveRow={handleSaveRow}
                        isFetching={isFetching}
                        paginationData={paginationData}
                        rowCount={rowCount}
                        selectionModel={selectionModel}
                        setFilterData={setFilterData}
                        setSelectionModel={setSelectionModel}
                        showEmptyState={showEmptyState}
                        tableSettings={tableSettings}
                    />
                </Card.Body>
            </Card>
        </Box>
    );
};

Content.propTypes = {
    contacts: PropTypes.array,
    filterContacts: PropTypes.func,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
    setFilterData: PropTypes.func,
    showEmptyState: PropTypes.object,
    tableSettings: PropTypes.array,
    users: PropTypes.array,
};

export default Content;
